import React, { useContext, useEffect, useState } from 'react';
import {
  CrudContext,
  usePromise,
} from '@digital/ui';
import { getUsuarioInfo, Usuario } from '@app/api/usuario';
import Perfil from '../Perfil/PerfilForm';
import { getAllAreasOptions } from '@app/api/area';
import TipoOptions from '@app/helpers/tipoOptions';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllDepartamentoOptions } from '@app/api/departamento';
import { getAllPerfilAcessoAdministradorId, PerfilAcessoResult } from '@app/api/PerfilAcesso';

interface UsuarioFormProps {
  onUpdate: () => void;
}

const UsuarioForm = (props: UsuarioFormProps) => {
  const { onUpdate } = props;
  const { selectedItem } = useContext(CrudContext);
  const [userInfo] = usePromise(
    () => (selectedItem ? getUsuarioInfo(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem],
    {} as Usuario,
  );

  const [diretoriaOptions, setDiretoriaOptions] = useState<TipoOptions[]>();
  const [areasOptions, setAreasOptions] = useState<TipoOptions[]>();
  const [departamentoOptions, setDepartamentoOptions] = useState<TipoOptions[]>();

  useEffect(() => {
    hasGetAllDiretoriasOptions();
    hasGetAllAreasOptions();
    hasGetAllDepartamentoOptions();
  }, []);

  const hasGetAllAreasOptions = () => {
    getAllAreasOptions().then((data) => {
      setAreasOptions(data);
    });
  }

  const hasGetAllDiretoriasOptions = () => {
    getAllDiretoriasOptions().then((data) => {
      setDiretoriaOptions(data);
    });
  }

  const hasGetAllDepartamentoOptions = () => {
    getAllDepartamentoOptions().then((data) => {
      setDepartamentoOptions(data);
    });
  }

  return <Perfil
    selectedItem={userInfo}
    onUpdate={onUpdate}
    diretoriaOptions={diretoriaOptions}
    areasOptions={areasOptions}
    departamentoOptions={departamentoOptions}
  />;
};

export default UsuarioForm;
